import { render, staticRenderFns } from "./LimpiezaHigiene.vue?vue&type=template&id=d5fededa&"
import script from "./LimpiezaHigiene.vue?vue&type=script&lang=js&"
export * from "./LimpiezaHigiene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports